'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Preis = require('../entity').Preis;

module.exports = function (connection) {
  return {
    byHatPreisgeldEquals: function byHatPreisgeldEquals(hatpreisgeld, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byHatPreisgeldEquals', 'hatpreisgeld')(hatpreisgeld, additionalParams);
    },
    byNamePreisEquals: function byNamePreisEquals(namepreis, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byNamePreisEquals', 'namepreis')(namepreis, additionalParams);
    },
    byNamePreisLike: function byNamePreisLike(namepreis, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byNamePreisLike', 'namepreis')(namepreis, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    byPreisBezeichnungEquals: function byPreisBezeichnungEquals(preisBezeichnung, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byPreisBezeichnungEquals', 'preisbezeichnung')(preisBezeichnung, additionalParams);
    },
    byPreisTraegerEquals: function byPreisTraegerEquals(preistraeger, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byPreisTraegerEquals', 'preistraeger')(preistraeger, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byVergebenDurchEquals: function byVergebenDurchEquals(vergebendurch, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byVergebenDurchEquals', 'vergebendurch')(vergebendurch, additionalParams);
    },
    byVergebenDurchLike: function byVergebenDurchLike(vergebendurch, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byVergebenDurchLike', 'vergebendurch')(vergebendurch, additionalParams);
    },
    byVerleihungsJahrEquals: function byVerleihungsJahrEquals(verleihungsjahr, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'byVerleihungsJahrEquals', 'verleihungsjahr')(verleihungsjahr, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'findAll', 'page')(page, additionalParams);
    },
    findOne: function findOne(projection, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'findOne', 'projection')(projection, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Preis, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Preis, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('preis')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/preis.js
// module id = KMat
// module chunks = 0